import { CardWrapper, ArrowIcon, ArrowLeft, ArrowRight, LaneScroller, NavigationArrow } from 'components/Lane/Lane.css';
import { styled } from 'components/ThemeConfigConnector/ThemeConfigConnnector';
import { fontBold } from 'style/styled-components/cssGlobalVariables';
import { Breakpoints, MQ, MQ_NOT_TOUCH } from 'style/styled-components/cssMediaQueries';
import { SliderTitle } from 'components/Slider/Slider.css';
import { TilesPlaceholder, TitlePlaceholder } from 'components/Stripes/StripeMixed/StripeMixedLoadingUI';
import { hexToRgba } from 'utils/fnColors';
import { CardFrame, ImageWrapper } from 'components/Cards/Card/Card.css';
import { ContentMarker } from 'style/styled-components/reusable.css';
import { buttonReset } from 'style/styled-components/cssButtonReset';

export const SeasonsSectionLabel = styled.span`
    width: 100px;
    display: inline-block;
    font-size: 20px;
    line-height: 40px;
    font-family: ${fontBold};
    color: ${(props) => props.theme.brandedConfig.high_contrast};
    margin-right: 15px;
    float: left;
`;

export const SeasonsLaneWrapper = styled.div`
    display: inline-block;
    width: 450px;
    float: left;

    ${LaneScroller} {
        display: flex;
        gap: 4px;
        margin: 0;
        padding: 2px; /* for :focus */
    }

    ${NavigationArrow} {
        width: 24px;
        height: 24px;
        top: 50%;
        transform: translateY(-50%);
        margin: 0;
        padding: 0;
        background: transparent;

        ${ArrowIcon} {
            left: 50%;
            right: auto;
            top: 50%;
            transform: translate(-50%, -50%);

            svg {
                width: 8px;
                height: 16px;
            }
        }
    }

    ${ArrowLeft} {
        left: -32px;
    }

    ${ArrowRight} {
        right: -32px;
    }
`;

export const SeasonNumber = styled.button<{ selected: boolean }>`
    ${buttonReset}
    display: flex;
    padding: 8px 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    background: ${(props) => (props.selected ? 'rgba(235, 235, 241, .2)' : 'transparent')};
    font-size: 16px;
    line-height: 24px;
    font-family: ${fontBold};
    color: ${(props) =>
        props.selected ? props.theme.brandedConfig.high_contrast : hexToRgba(props.theme.brandedConfig.high_contrast, 0.7)};
    padding: 8px 16px;
    border-radius: 4px;
    cursor: ${(props) => (props.selected ? 'default' : 'pointer')};
    scroll-snap-align: start;
    scroll-snap-stop: normal;

    &.partial,
    &.first-partial {
        opacity: 0.3;
    }

    &:focus-visible {
        outline: var(--focus-outline);
    }

    ${MQ_NOT_TOUCH} {
        &:hover {
            opacity: ${(props) => (props.selected ? 1 : 0.5)};
        }
    }
`;

export const SeasonsWrapper = styled.div`
    width: 100%;
    padding: 16px;

    ${MQ(Breakpoints.s)} {
        padding: 0 32px;
    }
    ${MQ(Breakpoints.m)} {
        padding: 0 72px;
    }

    &::after {
        content: '';
        display: block;
        clear: both;
    }
`;

export const EpisodesWrapper = styled.div<{ type: 'TV' | 'VOD' }>`
    margin-top: 12px;

    ${CardWrapper} {
        display: block;

        ${MQ(Breakpoints.s)} {
            display: inline-block;
        }
    }

    ${CardFrame} {
        width: auto;
        height: auto;

        ${ImageWrapper} {
            width: 90vw;
            /* height: calc(90vw * (9 / 16)); */
        }

        ${MQ(Breakpoints.s)} {
            ${ImageWrapper} {
                width: 100%;
                height: calc(90vw * (9 / 16));
            }
        }

        ${MQ(Breakpoints.xs)} {
            width: 100%;
            height: var(--card-image-height);

            ${ImageWrapper} {
                width: 100%;
                height: var(--card-image-height);
            }
        }
    }

    a[data-upcoming] {
        ${ImageWrapper} {
            &::after {
                content: '';
                position: absolute;
                inset: 0;
                background: #131320;
                opacity: 0.5;
                pointer-events: none;
            }
        }

        ${ContentMarker} {
            background-color: #2e2f42;
        }
    }

    ${SliderTitle}, ${TitlePlaceholder} {
        display: none;
    }

    ${TilesPlaceholder} {
        margin-bottom: 12px;
    }
`;

export const SeasonSelectorWrapper = styled.div`
    position: relative;
    width: 100%;
`;

export const SeasonSelectorWithLaneWrapper = styled.div`
    display: none;

    ${MQ(Breakpoints.xs)} {
        display: flex;
        align-items: center;
    }
`;

export const SeasonSelectorDropdownTrigger = styled.button`
    ${buttonReset}
    padding: 8px;
    border: 2px solid ${(props) => hexToRgba(props.theme.brandedConfig.high_contrast, 0.33)};
    color: ${(props) => props.theme.brandedConfig.high_contrast};
    display: inline-block;
    border-radius: 4px;
`;

export const SeasonSelectorDropdownContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    svg {
        display: block;
    }
`;

export const SeasonSelectorWithDropDown = styled.div`
    display: block;

    ${MQ(Breakpoints.xs)} {
        display: none;
    }
`;
